
<template>
    <div class="task-center-footer" :class="{'has-task-bg': missionStatus===1}">
        <div class="redirect-text" @click="goRedirectUrl">
            {{getRedirectName}}
        </div>
         <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="vertical-align:middle" ><path fill="#000" fill-rule="nonzero" d="M16.061 4.94l16.12 15.878a4.5 4.5 0 0 1 0 6.364l-16.12 15.879a1.5 1.5 0 0 1-2.122-2.122L30.06 25.061a1.5 1.5 0 0 0 0-2.122L13.94 7.061a1.5 1.5 0 1 1 2.121-2.122z"/></svg>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import {
  getScheme
} from '@/common/js/utils'
import {homepageTaskOrderButtonCk} from '../trackEvent'
const couponUrl = {
  br: 'https://food-c-h5.99app.com/${locale}\/user\/validCouponInfo?nativeWebUIType=2', // eslint-disable-line
  global: 'https://c-h5.didi-food.com/${locale}\/user\/validCouponInfo?nativeWebUIType=2' // eslint-disable-line
}
export default {
  name: 'TaskCenterFooter',
  props: ['missionStatus', 'taskOrderButtonCkData'],
  computed: {
    getRedirectName () {
      const text = {
        1: this.$t('FoodC_C_Go_tdhw'),
        2: this.$t('FoodC_C_View_Coupon_OIhv'),
        3: this.$t('FoodC_C_View_Coupon_OIhv')
      }
      return (this.missionStatus && text[this.missionStatus]) || this.$t('FoodC_C_View_Coupon_OIhv')
    },
    is99App () {
      // 是否是99app
      return this.$store.state.country === 'BR'
    }
  },
  methods: {
    ...mapActions({
      getGlobalInfo: 'getGlobalInfo'
    }),
    goRedirectUrl () {
      if (this.missionStatus === 1) {
        homepageTaskOrderButtonCk({
          button_type: 1,
          ...this.taskOrderButtonCkData
        }, () => {
          location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
        })
        return
      }
      homepageTaskOrderButtonCk({
        button_type: 2,
        ...this.taskOrderButtonCkData
      }, () => {
        this.SodaBridge('openPage', {
          target: 'blank',
          url: this.is99App ? couponUrl.br : couponUrl.global
        })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.has-task-bg
  background #F8F8F8
.task-center-footer
    display flex
    justify-content center
    font-size 28px
    padding-bottom 40px 
    align-items center
    .redirect-text
        font-family 'Aspira Light'
        font-size 28px
        color #000000
        text-align left
        font-weight 200
        margin-right 4px
        padding-left 10px 
    svg
      width 24px
      height 24px
</style>